import { render, staticRenderFns } from "./SurveyQuestionResponses.vue?vue&type=template&id=64c8e841&scoped=true"
import script from "./SurveyQuestionResponses.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionResponses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c8e841",
  null
  
)

export default component.exports